import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/core/_config/app.config';
import { DueDateInBatchesParams } from '../models/due-date-in-batches-params.model';
import DueDateInBatches from '../models/due-date-in-batches.model';

@Injectable({
    providedIn: 'root',
})
export class DueDateInBatchesService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(private http: HttpClient, private config: AppConfig) {}

    private anyToHttpParams(obj: any, getNull: boolean = true): HttpParams {
        let params = new HttpParams();
        Object.keys(obj).forEach(function (item) {
            if (obj[item] == null && getNull) {
                params = params.set(item, obj[item]);
            } else if (obj[item] != null) {
                params = params.set(item, obj[item]);
            }
        });
        return params;
    }

    public getDueDateInBatches(params: DueDateInBatchesParams): Observable<any> {
        return this.http.get(`${this.API_URL}DueDateInBatches`, { params: this.anyToHttpParams(params, false) });
    }

    public getPeriodsByLegalEntity(legalEntityId: string): Observable<any> {
        return this.http.get(`${this.API_URL}DueDateInBatches/GetPeriodsByLegalEntity`, {
            params: { legalEntityId: legalEntityId },
        });
    }

    public getServicesByLegalEntity(legalEntityId: string): Observable<any> {
        return this.http.get(`${this.API_URL}DueDateInBatches/GetServicesByLegalEntity`, {
            params: { legalEntityId: legalEntityId },
        });
    }

    public getDueDaysByLegalEntity(legalEntityId: string): Observable<any> {
        return this.http.get(`${this.API_URL}DueDateInBatches/GetDueDaysByLegalEntity`, {
            params: { legalEntityId: legalEntityId },
        });
    }

    public postAlterDueDateInBatch(
        periodId: string,
        dueDateStart: string,
        billets: Array<DueDateInBatches>,
        newDueDate: string,
        allBilletsByFilter: boolean,
        accompaniesDiscount: boolean,
        legalEntityId: string,
        dueDateFinal: string = null,
        serviceId: string = null
    ): Observable<any> {
        return this.http.post(`${this.API_URL}DueDateInBatches/AlterDueDateInBatch`, billets, {
            params: this.anyToHttpParams(
                {
                    periodId,
                    dueDateStart,
                    newDueDate,
                    accompaniesDiscount,
                    allBilletsByFilter,
                    legalEntityId,
                    dueDateFinal,
                    serviceId,
                },
                false
            ),
        });
    }
}
